import { QueryBuilder } from 'components/resources/triggers/QueryBuilder';
import Button from 'components/utils/Button';
import { H4 } from 'components/utils/typo';
import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Condition } from './ConditionalTextForm';

interface ConditionalTextConditionFormProps {
  conditionData: Condition;
  onSave?: (condition, conditionJson, conditionLogic) => void;
  onCancel?: () => void;
}

export const ConditionalTextConditionForm = ({
  conditionData,
  onSave,
  onCancel,
}: ConditionalTextConditionFormProps) => {
  const [condition, setCondition] = useState<string | null>(conditionData.condition);
  const [conditionJson, setConditionJson] = useState(conditionData.builder_condition_json);
  const [conditionLogic, setConditionLogic] = useState(conditionData.condition_logic);

  return (
    <div className='flex h-full flex-col'>
      <div className='grow overflow-y-auto'>
        <div className='sticky top-0 z-10 flex items-center justify-between bg-white pl-4 pr-3 pt-[20px]'>
          <H4>Condition</H4>
          <div className='cursor-pointer' onClick={onCancel}>
            <X size={20} />
          </div>
        </div>
        <div className='mt-4 px-4'>
          <QueryBuilder
            setChoiceMapping={() => {}} // will be deprecated
            setCondition={(condition) => setCondition(condition)}
            setConditionLogic={setConditionLogic}
            setQueryValue={(json: any) => setConditionJson(json)}
            queryValue={conditionData.builder_condition_json}
          />
        </div>
      </div>
      <div className='shrink-0'>
        <div className='flex justify-end gap-2 px-3 pb-[22px] pt-3'>
          <div className='flex'>
            <Button.Reverse type='button' onClick={onCancel}>
              Cancel
            </Button.Reverse>
          </div>
          <div className='flex w-[80px]'>
            <Button
              type='button'
              onClick={() => onSave?.(condition, conditionJson, conditionLogic)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
